




















import MatronItem from '../common/matron_item.vue'
import { Component, Mixins, Inject, Provide } from 'vue-property-decorator'
import SearchCategory from '../common/search_category.vue'
import SearchLoadList from '../mixins/LoadList'
import Screen from '../common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    MatronItem,
    SearchCategory,
    Screen
  }
})
export default class SearchYueSao extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setYueSaoNum!: (arg: number) => void

  // @searchResModule.State districtList!: any
  // @searchResModule.State yueSaoDistrictSelect!: any
  // @searchResModule.Mutation setYueSaoDistrictSelect!: (arg: any) => void

  @searchResModule.State levelList!: any
  @searchResModule.State yueSaoLevelSelect!: any
  @searchResModule.Mutation setYueSaoLevelSelect!: (arg: any) => void

  @searchResModule.State bRightList!: any
  @searchResModule.State yueSaoBrightSelect!: any
  @searchResModule.Mutation setYueSaoBrightSelect!: (arg: any) => void

  @searchResModule.Mutation resetYueSao!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200010')
  clickid_200010!: string
  @Provide()
  clickid_200004 = '200006'

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshMatron, () => {
        this.refresh()
      })
    }, 1000)
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshMatron)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  get classifyExposure() {
    return `${this.clickid_200010}`
  }

  changeYueSaoBright(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200010, positionParam: { searchtype: '亮点' } })
    this.setYueSaoBrightSelect(value)
    this.refresh()
  }

  changeYueSaoLevel(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200010, positionParam: { searchtype: '等级' } })
    this.setYueSaoLevelSelect(value)
    this.refresh()
  }

  // changeYueSaoDistrict(value: any) {
  //   this.setYueSaoDistrictSelect(value)
  //   this.refresh()
  // }

  async onLoad() {
    const { starLevel = '' } = this.yueSaoLevelSelect || {}
    const { lightExperience = '' } = this.yueSaoBrightSelect || {}
    // const { ID = '' } = this.yueSaoDistrictSelect || {}
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestMatron, start: this.start, starLevel, lightExperience })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.maternityInfo) {
        const { total, list: newData = [] } = data.maternityInfo
        this.setYueSaoNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetYueSao()
    this.refresh()
  }
}
